// Year / Conditions / Events / Export chips drawn on `#s08` at every band.
import { Link, useLocation } from 'react-router-dom';
import { scopeHref } from '@/app/shell/scope';

export function BusinessNav({
  conditionCount,
  eventCount,
  eventHref,
}: {
  conditionCount?: number | null;
  eventCount?: number | null;
  eventHref?: string | null;
}) {
  const { pathname, search } = useLocation();
  const tabs = [
    { key: 'year', href: '/business', label: 'Year', active: pathname === '/business' },
    {
      key: 'conditions',
      href: '/business/conditions',
      label: conditionCount != null ? `Conditions · ${conditionCount}` : 'Conditions',
      active: pathname.startsWith('/business/conditions'),
    },
    {
      key: 'events',
      href: eventHref ?? '/business',
      label: eventCount != null ? `Events · ${eventCount}` : 'Events',
      active: pathname.startsWith('/events'),
    },
    {
      key: 'export',
      href: '/business/export',
      label: 'Export',
      active: pathname.startsWith('/business/export'),
    },
  ];
  return (
    <nav aria-label="Business views" className="my-3 flex flex-wrap gap-2 text-xs" data-testid="business-nav">
      {tabs.map((tab) => (
        <Link
          key={tab.key}
          to={scopeHref(tab.href, search)}
          aria-current={tab.active ? 'page' : undefined}
          data-testid={`business-nav-${tab.key}`}
          className="ms-tap-44 inline-flex min-h-11 min-w-11 items-center justify-center font-medium"
        >
          <span
            className={[
              'inline-flex min-h-11 items-center rounded-full border px-3 py-1',
              tab.active ? 'border-transparent bg-foreground text-background' : 'border-input bg-background text-foreground',
            ].join(' ')}
          >
            {tab.label}
          </span>
        </Link>
      ))}
    </nav>
  );
}

export default BusinessNav;
